export default __webpack_public_path__ + "static/media/thomas.feb8b9f4.jpg";